import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environment/environment';
var QuickScansService = /** @class */ (function () {
    function QuickScansService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.API_BASE + '/quickscan';
    }
    /**
     * Create new quick scan request
     * @method createQuickScan
     */
    QuickScansService.prototype.createQuickScan = function (newScan) {
        return this.httpClient.post(this.baseUrl + "/search/", newScan);
    };
    /**
     * Get info about quick scan by id
     * @method getQuickScan
     */
    QuickScansService.prototype.getQuickScan = function (id) {
        return this.httpClient.get(this.baseUrl + "/records/" + id + "/");
    };
    /**
     * Get info about quick scans
     * @method getQuickScans
     */
    QuickScansService.prototype.getQuickScans = function (quickScansReqBody) {
        var params = new HttpParams();
        if (quickScansReqBody) {
            var reqBodyEntries = Object.entries(quickScansReqBody);
            reqBodyEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(this.baseUrl + "/search/", { params: params });
    };
    /**
     * Batch upload file
     * @method batchUpload
     */
    QuickScansService.prototype.batchUpload = function (data) {
        return this.httpClient.post(this.baseUrl + "/records/bulk_create/", data);
    };
    return QuickScansService;
}());
export { QuickScansService };
